const STATUS_LABELS = {
  delivered: 'Delivered',
  failed: 'Failed',
  pending: 'Pending',
  read: 'Read',
  sent: 'Sent'
};

export function formatCount(value) {
  const numericValue = Number(value) || 0;
  return new Intl.NumberFormat('en-US').format(numericValue);
}

export function formatDateTime(value) {
  if (!value) {
    return '--';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  return date.toLocaleString();
}

export function formatTimeValue(value) {
  if (!value) {
    return '--';
  }

  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(String(value))) {
    return String(value);
  }

  if (/^\d{2}:\d{2}:\d{2}$/.test(String(value))) {
    return String(value);
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  return date.toLocaleString('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
}

export function formatRequestId(value) {
  if (!value) {
    return '--';
  }

  const parts = String(value).split('_');
  if (parts.length !== 2) {
    return String(value);
  }

  const [uuidPart, timestamp] = parts;
  if (!uuidPart.includes('-')) {
    return `${uuidPart}_${timestamp}`;
  }

  const finalChunk = uuidPart.split('-').pop() || uuidPart.replace(/-/g, '');
  return `${finalChunk.slice(0, 9)}_${timestamp}`;
}

export function formatStatusLabel(status) {
  return STATUS_LABELS[status] || status || 'Unknown';
}

export function shortenId(value, length = 18) {
  if (!value) {
    return '--';
  }

  if (value.length <= length) {
    return value;
  }

  return `${value.slice(0, length)}...`;
}
